import { toValue, type MaybeRefOrGetter } from 'vue';
import { useTitle } from '@vueuse/core';

export const ADMIN_TITLE = 'OhMyBible Admin';

/**
 * The browser tab title of an admin page: "<page> · OhMyBible Admin", so every
 * admin tab says which app it belongs to (the user app shares the domain).
 */
export const usePageTitle = (title: MaybeRefOrGetter<string>) =>
  useTitle(() => toValue(title), { titleTemplate: `%s · ${ADMIN_TITLE}` });
